module.exports = __webpack_public_path__ + "static/img/23.071999b8.gif";